<template>
  <el-dialog
      v-model="dialogVisible"
      title="管理专家"
      width="960px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1 d-flex justify-content-center">
      <el-transfer v-model="choised"
                   filter-placeholder="输入关键词搜索"
                   :data="specialList"
                   filterable
                   :titles="['专家列表', '已选专家']">
        <template #left-empty>
          <el-empty :image-size="60" description="无可添加专家" />
        </template>
        <template #right-empty>
          <el-empty :image-size="60" description="暂无专家" />
        </template>
        <template #default="{ option }">
          <p class="p-0 mb-0 fw-bold pub-one-row">
            {{ option.username }}
            <text v-if="option.real_name"> &nbsp;&nbsp; {{ option.real_name }}</text>
            <text v-if="option.company"> &nbsp;&nbsp; {{ option.company }}</text>
          </p>
<!--          <p class="p-0 mb-0 small">单位：{{option.company || "无"}}</p>-->
        </template>
      </el-transfer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {addExpertToWorkgroup, getWorkgroupDetail, removeExpertFromWorkgroup} from "@/api/workgroupAdmin";
import {getJudges} from "@/api/specialAdmin";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
let originChoisedExpertData = [] // 原始的专家列表
const ruleFormRef = ref()

const formData = reactive({

})
const loading = ref(false)

const specialList = ref([])
const choised = ref([])

const props = defineProps({
  item: {
    default: {},
  },
  stage:{
    default:null
  }
})
// 开始
onMounted(()=>{
  formData.ID = props.item.ID
  getDetail()
})



const getDetail = async ()=>{
  try {
    const special = await getJudges({current:1,pageSize:100000}) // 获取所有专家
    const detail = await getWorkgroupDetail({id:props.item.ID}) //props.item.ID // 获取详情
    let specialAllData = []
    let specialCheckedData = []
    if(special.success){
      specialAllData = special.data || []
    }
    if(detail.err_code === 0 && detail.data && detail.data.Experts){
      specialCheckedData =  detail.data.Experts || []
      choised.value = specialCheckedData.map(item=>item.id)
      originChoisedExpertData =  specialCheckedData.map(item=>item.id)
    }
    specialAllData.forEach(item=>{
      item.key = item.id
      item.label = item.real_name
    })
    specialList.value = specialAllData
  }catch (err){
    return ElMessage.success("无法获取信息")
  }



}

const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async () => {


  loading.value = true
  if(originChoisedExpertData && originChoisedExpertData.length>0){
    const delRes = await removeExpertFromWorkgroup({WorkgroupId:props.item.ID,ExpertIds:originChoisedExpertData})
    if(delRes.err_code!==0){
     return
    }
  }
  if(choised.value && choised.value.length>0){
    const addRes = await addExpertToWorkgroup({WorkgroupId:props.item.ID,ExpertIds:choised.value})
    if(addRes.err_code===0){
      ElMessage.success("保存成功")
      emits("success", true)
    }else{
      ElMessage.warning("保存失败")
    }
  }else{
    ElMessage.success("保存成功")
    emits("success", true)
  }

  loading.value = false



}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  max-height: 800px;
  overflow-x: hidden;
  overflow-y: auto;
}

::v-deep.el-transfer-panel{
  width: 200px !important;
}
</style>
